/**
 * @generated SignedSource<<9e911ecf60bed1c8cb6f0f3da090d71e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SignInInput = {
  clientMutationId?: string | null | undefined;
  email: string;
  password: string;
};
export type SessionProviderSignInMutation$variables = {
  input: SignInInput;
};
export type SessionProviderSignInMutation$data = {
  readonly signIn: {
    readonly error: string | null | undefined;
    readonly user: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type SessionProviderSignInMutation = {
  response: SessionProviderSignInMutation$data;
  variables: SessionProviderSignInMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SignInPayload",
    "kind": "LinkedField",
    "name": "signIn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionProviderSignInMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SessionProviderSignInMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "537ddcf6023714b5b28d34326b0eb717",
    "id": null,
    "metadata": {},
    "name": "SessionProviderSignInMutation",
    "operationKind": "mutation",
    "text": "mutation SessionProviderSignInMutation(\n  $input: SignInInput!\n) {\n  signIn(input: $input) {\n    error\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a8e2749c74be7ccffefbffbe22db145";

export default node;
